import { createSelector } from "reselect";
import { EntitiesMap, DenormalizedSection, CompanyMembership } from "../entities";

export const denormalizedSectionSelector = createSelector(
  (entities: EntitiesMap, membershipIds: EntityId[]) => membershipIds.map(id => entities.company_memberships[id]!),
  (entities: EntitiesMap, _membershipIds: EntityId[], membershipSectionIds: EntityId[]) =>
    membershipSectionIds.map(id => entities.company_membership_sections[id]!),
  (memberships, sections): DenormalizedSection[] => {
    const membersMap: { [key: string]: CompanyMembership[] | undefined } = {};
    const restMembers: CompanyMembership[] = [];
    memberships.sort((a, b) => a.display_order - b.display_order).forEach(mem => {
      if (mem.section) {
        membersMap[mem.section] = membersMap[mem.section] || [];
        membersMap[mem.section]!.push(mem);
      } else {
        restMembers.push(mem);
      }
    });
    const res: DenormalizedSection[] = [];
    sections.sort((a, b) => a.display_order - b.display_order).forEach(section => {
      res.push({
        section,
        memberships: membersMap[section.id] || [],
      });
    });
    res.push({
      section: undefined,
      memberships: restMembers,
    });
    return res;
  }
);

export const featuredMembershipsSelector = createSelector(
  (entities: EntitiesMap, membershipIds: EntityId[]) => membershipIds.map(id => entities.company_memberships[id]!),
  memberships => {
    memberships = memberships.filter(mem => mem.featured_display_order >= 0);
    return memberships.sort((a, b) => a.featured_display_order - b.featured_display_order);
  }
);



// WEBPACK FOOTER //
// ./frontend/src/company_memberships/selectors/index.ts